import { render, staticRenderFns } from "./textArea.vue?vue&type=template&id=216c9417&scoped=true"
import script from "./textArea.vue?vue&type=script&lang=js"
export * from "./textArea.vue?vue&type=script&lang=js"
import style0 from "./textArea.vue?vue&type=style&index=0&id=216c9417&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216c9417",
  null
  
)

export default component.exports